<mat-form-field *ngIf="!isTextarea; else textarea" [class]="this.size>0 ? 'sized' : ''">
  <mat-label *ngIf="label">{{ useLabelTranslation ? (label | translate) : label}}</mat-label>

  <mat-icon *ngIf="prefixIcon" matPrefix color="primary">{{prefixIcon}}</mat-icon>
  <input [type]="type" matInput [formControl]="$any(control.control)" (ngModelChange)="onChangeModel($event)"
    [matAutocomplete]="auto" #inputElement (input)="onSearch($event)" (focus)="onFocusSearch($event)" nullValue>
  <mat-icon *ngIf="hasDeleteBtn" matSuffix role="button" (click)="onClickDeleteBtn()" color="primary"
    appTooltip="{{'enum.SubmitType.DELETE' | translate}}">delete_forever</mat-icon>
  <mat-icon *ngIf="hasValidateBtn" matSuffix role="button" (click)="onClickValidateBtn()" color="primary"
    appTooltip="{{'enum.SubmitType.VALIDATE' | translate}}">check</mat-icon>

  <mat-icon *ngIf="suffixIcon" matSuffix>{{suffixIcon}}</mat-icon>
  <span *ngIf="suffixText" matSuffix>{{suffixText}}</span>
  <mat-hint *ngIf="hint">{{hint}}</mat-hint>

  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)">
    <mat-option *ngFor="let option of autoCompletedOptions; let i = index"
      [value]="displayType==='email' ? option.email : option" (click)="onClickOption(option, autocompletionDisabled[i])"
      [disabled]="autocompletionDisabled[i]">
      {{autocompletionDisplayNames[i]}}
    </mat-option>
    <mat-option *ngIf="autocompletionShowNoResult && !autocompletionHideNoResult" disabled>
      {{'noResult' | translate}}
    </mat-option>
  </mat-autocomplete>

  <mat-error *ngIf="this.control.form.errors">
    <app-error-message [errors]="this.control.form.errors" [patternErrorLabel]="patternErrorLabel"></app-error-message>
  </mat-error>
</mat-form-field>


<ng-template #textarea>
  <mat-form-field [class]="this.size>0 ? 'sized' : ''">
    <mat-label>{{label | translate}}</mat-label>
    <textarea appEmptyToNull matInput [formControl]="$any(control.control)" (change)="onChange($event)"></textarea>
  </mat-form-field>
</ng-template>